(() => {
  const brandIconSrc = new URL("ws-brand-icon-light.svg?v=smooth-edge-20261016", document.currentScript.src).href;
  // docs/frontend/review/two-plan-draft-2026-10-06/src/data.js
  var iconPrefix = "ws2p-";
  var setIconPrefix = (value) => {
    iconPrefix = value || "ws2p-";
  };
  var icon = (name, extra = "") => `<svg class="wsmp-icon ${extra}" aria-hidden="true"><use href="#${iconPrefix}${name}"/></svg>`;
  var plans = [
    {
      key: "complete",
      prices: { monthly: 249 },
      tone: "personal",
      name: "Complete",
      label: "The full experience",
      visual: 2,
      intro: "Your plans, a dedicated coach and tailored supplement delivery.",
      benefits: ["Everything in Training & Nutrition", "More one-to-one coaching", "Supplement home delivery"],
      lead: "One coach who keeps the whole picture in view.",
      explanation: "Training, food, your follow-ups and relevant supplements \u2014 brought together with a dedicated coach who gets to know your routine.",
      features: ["Personalised training and nutrition plans", "Supplement guidance where relevant", "AI plan assistant for questions and follow-ups", "More one-to-one coaching and direct coach contact", "A dedicated coach following your plan over time", "Tailored supplement home delivery, where appropriate"],
      extra: "Suggested distinction: your coach proactively reviews your progress and agrees the next steps with you.",
      terms: "Coaching time, contact frequency and response times still need to be defined. Supplement range, included quantity or value, shipping areas, delivery frequency and the option when no supplement is appropriate also need to be agreed."
    },
    {
      key: "training-nutrition",
      prices: { monthly: 149 },
      tone: "plan",
      name: "Training & Nutrition",
      label: "Your everyday foundation",
      visual: 0,
      intro: "Personalised plans, practical AI help and a lighter level of coaching.",
      benefits: ["Training, nutrition & supplement guidance", "AI plan assistant", "Limited personal coaching"],
      lead: "A clear plan for how you move and eat.",
      explanation: "Bring your workouts, meals and relevant supplement guidance into one place, with AI help for everyday plan questions and a defined level of personal coaching.",
      features: ["Personalised training and nutrition plans", "Supplement guidance where relevant", "AI plan assistant for questions and follow-ups", "A defined, limited amount of personal coaching"],
      extra: "The AI assistant is identified as AI. Its proposed role is to explain your plan, help with routines and prepare follow-ups; questions requiring individual professional judgement go to a coach.",
      terms: "The human coaching allowance and the AI assistant\u2019s supported actions still need to be confirmed. Physical supplement deliveries are part of the Complete proposal."
    }
  ];
  function phoneVisual(index, focus) {
    const complete = index === 2;
    const navItem = (symbol, label, active = false) => '<span class="pui-nav-item' + (active ? ' is-active' : '') + '">' + (symbol === 'learn' ? '<svg class="wsmp-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v15M12 5C9 3 6 3 3 4v14c3-1 6-1 9 2 3-3 6-3 9-2V4c-3-1-6-1-9 1Z" fill="none" stroke="currentColor" stroke-linejoin="round"/></svg>' : icon(symbol)) + '<small>' + label + '</small></span>';
    const support = complete
      ? '<span class="pui-support-icon">' + icon('personal') + '</span><span><strong>Your personal coach</strong><small>Support for your next step</small></span>'
      : '<span class="pui-support-icon">' + icon('guided') + '</span><span><strong>AI plan assistant</strong><small>Help with your everyday plan</small></span>';
    const screen = '<div class="pui-heading"><span class="pui-kicker">YOUR PERSONAL PLAN</span><h4>Your day.<br>All together.</h4></div>'
      + '<div class="pui-week">' + ['M','T','W','T','F','S','S'].map((d,i) => '<span class="' + (i === 1 ? 'is-today' : '') + '">' + d + '<i></i></span>').join('') + '</div>'
      + '<div class="pui-workout"><div class="pui-workout-copy"><span class="pui-kicker">TODAY\u2019S TRAINING</span><strong>Full-body<br>strength</strong><span class="pui-workout-link">View workout ' + icon('arrow') + '</span></div><div class="pui-workout-art">' + icon('training') + '</div></div>'
      + '<div class="pui-meals"><span class="pui-meal-icon">' + icon('nutrition') + '</span><span><strong>Meals for your day</strong><small>Built around your routine</small></span>' + icon('chevron','pui-chevron') + '</div>'
      + '<div class="pui-support' + (complete ? ' pui-support--coach' : '') + '">' + support + icon('arrow','pui-support-arrow') + '</div>';
    return '<div class="wsmp-phone wsmp-phone--product"><span class="phone-side-key"></span><div class="phone-screen"><div class="phone-status"><span>9:41</span><span>\u25B0 \u25B0</span></div><div class="phone-island"></div><div class="phone-brand"><img class="phone-brand-icon" src="' + brandIconSrc + '" alt="" width="14" height="14" aria-hidden="true"><span>WeightStart</span><small class="pui-preview">Preview</small></div><div class="pui-content">' + screen + '</div><div class="pui-nav">' + navItem('complete','Home',true) + navItem('plan','My plan') + navItem('learn','Learn') + navItem('guided','Chat') + '</div><div class="phone-home"></div></div></div>';
  }
  var priceLabel = (plan) => `$${plan.prices.monthly} USD / month`;
  function homeUrl(root) {
    const url = new URL(root.dataset.homeUrl || "/", location.origin);
    const current = new URL(location.href);
    for (const key of ["preview_theme_id", "pb", "_fd", "_sc", "preview_key"]) if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    if (!url.searchParams.has("preview_theme_id") && window.Shopify?.theme?.role === "unpublished") url.searchParams.set("preview_theme_id", String(window.Shopify.theme.id));
    return url;
  }
  function detailUrl(root, plan, period) {
    const url = homeUrl(root);
    url.searchParams.set("view", "ws-membership");
    url.searchParams.set("membership", plan);
    url.searchParams.set("period", "monthly");
    return url.href;
  }

  // docs/frontend/review/two-plan-draft-2026-10-06/src/list.js
  function init(root) {
    const stateContext = root.dataset.stateContext === "memberships" ? "memberships" : "homepage";
    const stateKey = "ws-two-plan-carousel-" + (window.Shopify?.theme?.id || "local") + "-" + stateContext;
    const controller = new AbortController();
    const cleanups = [];
    const on = (target, type, handler, options = {}) => target.addEventListener(type, handler, { ...options, signal: controller.signal });
    setIconPrefix(root.dataset.iconPrefix);
    const motion = matchMedia("(prefers-reduced-motion: reduce)");
    const carousels = [];
    let activeLink = null;
    for (const carousel of root.querySelectorAll("[data-carousel]")) {
      const grid = carousel.querySelector(".two-plan-grid");
      const period = "monthly";
      grid.innerHTML = plans.map((p, i) => `<article class="wsmp-plan-card" data-level="${p.tone}" role="group" aria-roledescription="slide" aria-label="${i + 1} of 2: ${p.name}"><div class="wsmp-card-visual" aria-hidden="true"><div class="wsmp-phone-shadow"></div>${phoneVisual(p.visual, "complete")}</div><div class="wsmp-card-body"><p class="wsmp-inclusion-label">${p.label}</p><h4 class="ws2p-card-title">${p.name}</h4><p class="package-price">${priceLabel(p, period)}</p><a class="wsmp-button" href="${detailUrl(root, p.key, period)}" data-plan="${p.key}" data-period="${period}" aria-label="More information: ${p.name}, monthly">More information</a></div></article>`).join("");
      let index = 0, frame = 0, drag = null, suppressUntil = 0;
      const max = () => Math.max(0, grid.scrollWidth - grid.clientWidth);
      const update = () => {
        const end = max();
        index = end > 1 && grid.scrollLeft > end / 2 ? 1 : 0;
      };
      const go = (target, smooth = true) => {
        index = target === 1 ? 1 : 0;
        grid.scrollTo({ left: index * max(), behavior: smooth && !motion.matches ? "smooth" : "instant" });
        if (!smooth || motion.matches) update();
      };
      on(grid, "scroll", () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      }, { passive: true });
      on(grid, "keydown", (event) => {
        if (event.target !== grid) return;
        const target = { ArrowLeft: 0, Home: 0, ArrowRight: 1, End: 1 }[event.key];
        if (target !== void 0) {
          event.preventDefault();
          go(target);
        }
      });
      on(grid, "pointerdown", (event) => {
        if (event.pointerType !== "mouse" || event.button !== 0 || event.target.closest("a,button")) return;
        drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: grid.scrollLeft, moved: false };
      });
      on(grid, "pointermove", (event) => {
        if (!drag) return;
        const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
        if (!drag.moved && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) {
          drag.moved = true;
          grid.setPointerCapture(drag.id);
          grid.classList.add("is-dragging");
        }
        if (drag.moved) {
          event.preventDefault();
          grid.scrollLeft = drag.left - dx;
        }
      });
      const endDrag = () => {
        if (!drag) return;
        const moved = drag.moved;
        const target = grid.scrollLeft > max() / 2 ? 1 : 0;
        if (grid.hasPointerCapture(drag.id)) grid.releasePointerCapture(drag.id);
        drag = null;
        grid.classList.remove("is-dragging");
        if (moved) {
          suppressUntil = performance.now() + 250;
          go(target);
        }
      };
      on(grid, "pointerup", endDrag);
      on(grid, "pointercancel", endDrag);
      on(grid, "lostpointercapture", () => {
        if (drag) {
          drag = null;
          grid.classList.remove("is-dragging");
        }
      });
      on(grid, "pointerleave", () => {
        if (drag && !drag.moved) drag = null;
      });
      on(grid, "click", (event) => {
        if (performance.now() < suppressUntil) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true });
      const resize = new ResizeObserver(() => go(index, false));
      resize.observe(grid);
      cleanups.push(() => {
        resize.disconnect();
        cancelAnimationFrame(frame);
      });
      on(motion, "change", () => {
        if (motion.matches) go(index, false);
      });
      carousels.push({ period, getIndex: () => index, go });
      update();
    }
    for (const card of root.querySelectorAll(".wsmp-plan-card")) {
      on(card, "pointerenter", (event) => {
        if (event.pointerType === "mouse" && !motion.matches) card.classList.add("wsmp-phone-hover");
      });
      on(card, "pointerleave", () => card.classList.remove("wsmp-phone-hover"));
    }
    on(motion, "change", () => {
      if (motion.matches) root.querySelectorAll(".wsmp-phone-hover").forEach((e) => e.classList.remove("wsmp-phone-hover"));
    });
    const save = () => {
      try {
        sessionStorage.setItem(stateKey, JSON.stringify({ indices: carousels.map((c) => c.getIndex()), scroll: scrollY, activeLink }));
      } catch {
      }
    };
    on(root, "click", (event) => {
      const link = event.target.closest("a[data-plan]");
      if (!link) return;
      activeLink = { plan: link.dataset.plan, period: link.dataset.period };
      save();
      try {
        sessionStorage.setItem(stateKey + "-return", "1");
      } catch {
      }
    });
    on(window, "pagehide", save);
    let stored = null;
    try {
      if (sessionStorage.getItem(stateKey + "-return") === "1") {
        stored = JSON.parse(sessionStorage.getItem(stateKey));
        sessionStorage.removeItem(stateKey + "-return");
      }
    } catch {
    }
    const layoutReady = Promise.all([document.fonts.ready, new Promise((resolve) => {
      if (document.readyState === "complete") resolve();
      else on(window, "load", resolve, { once: true });
    })]);
    if (stored) layoutReady.then(() => requestAnimationFrame(() => {
      if (controller.signal.aborted) return;
      carousels.forEach((c, i) => c.go(stored.indices?.[i] === 1 ? 1 : 0, false));
      const period = stored.activeLink?.period === "monthly" ? "monthly" : null;
      const plan = plans.find((p) => p.key === stored.activeLink?.plan)?.key;
      if (period && plan) root.querySelector(`a[data-plan="${plan}"][data-period="${period}"]`)?.focus({ preventScroll: true });
      window.scrollTo({ top: Number(stored.scroll) || 0, behavior: "instant" });
    }));
    return () => {
      controller.abort();
      cleanups.forEach((fn) => fn());
    };
  }
  if (!customElements.get("ws-two-memberships")) customElements.define("ws-two-memberships", class extends HTMLElement {
    connectedCallback() {
      if (!this.cleanup) this.cleanup = init(this);
    }
    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
  });
})();
